import type { SchemaField } from '@cli-types/core-engine/schema.js'
export function generateFieldMapping(field: SchemaField, source = 'input'): string {
  if (field.type === 'list') return `${source}.${field.name} || []`
  if (field.type === 'select' && field.multiple) return `${source}.${field.name} ?? []`
  if (field.type === 'relationship') {
    if (field.multiple) return `${source}.${field.name} ?? []`
    return field.required
      ? `${source}.${field.name}`
      : `${source}.${field.name} && ${source}.${field.name} !== '' ? ${source}.${field.name} : null`
  }
  if (
    (field.type === 'date' || field.type === 'timestamp' || field.type === 'time') &&
    !field.required
  ) {
    return `${source}.${field.name} && ${source}.${field.name} !== '' ? ${source}.${field.name} : null`
  }
  if (!field.required && ['string', 'email', 'varchar', 'text', 'select'].includes(field.type)) {
    return `${source}.${field.name} && ${source}.${field.name} !== '' ? ${source}.${field.name} : null`
  }
  return `${source}.${field.name}`
}
